import {api} from "./index";

export const mailApi = api.injectEndpoints({
  endpoints: (build) => ({
    mailList: build.mutation({
      query(body) {
        return {
          url: `mail-list`,
          method: 'POST',
          headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
          body: body
        }
      }
    }),
  }),
});

export const {
  useMailListMutation,
} = mailApi;
